// extracted by mini-css-extract-plugin
export default {"wrap":"activityAnswer_wrap__lu+Fd","solution":"activityAnswer_solution__NcXT8","buttons":"activityAnswer_buttons__+S2mF"};